<div class="notification-settings-backdrop" [class.show]="isOpen" (click)="onClose()"></div>

<div class="notification-settings-panel" [class.open]="isOpen" [class.dark-theme]="isDarkMode" [class.light-theme]="!isDarkMode">
  <!-- Header with back arrow and title -->
  <div class="notification-panel-header">
    <button type="button" class="panel-back-btn" (click)="onClose()" title="Back">
      <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
        <line x1="19" y1="12" x2="5" y2="12"></line>
        <polyline points="12 19 5 12 12 5"></polyline>
      </svg>
    </button>
    <h5 class="panel-header-title">Notifications</h5>
  </div>

  <!-- Body -->
  <div class="notification-panel-body">
    <!-- Messages Section -->
    <div class="notification-section">
      <h6 class="section-title">Messages</h6>
      <div class="setting-row">
        <span class="setting-label">Mute notifications</span>
        <label class="toggle-switch">
          <input type="checkbox" [checked]="muteNotifications" (change)="toggleMuteNotifications()" />
          <span class="toggle-slider"></span>
        </label>
      </div>
    </div>

    <!-- Calls Section -->
    <div class="notification-section">
      <h6 class="section-title">Calls</h6>
      <div class="setting-row">
        <span class="setting-label">Mute calls</span>
        <label class="toggle-switch">
          <input type="checkbox" [checked]="muteCalls" (change)="toggleMuteCalls()" />
          <span class="toggle-slider"></span>
        </label>
      </div>
    </div>
  </div>
</div>
